module.exports = __webpack_public_path__ + "img/shopping-bag-seven.88ad2115.svg";